import { takeLatest } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { CUSTOMER_ACTIONS } from "./actionTypes";
import { CustomersApi } from "./api";
/**
 * Create customer
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{customers, type}>|CallEffect|PutEffect<{type}>>}
 */

function* create(action) {
  yield SagasHelper.action(action, CustomersApi.create);
}
/**
 * View customer
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{customers, type}>|CallEffect|PutEffect<{type}>>}
 */


function* view(action) {
  yield SagasHelper.action(action, CustomersApi.view);
}
/**
 * List customers
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{customers, type}>|CallEffect|PutEffect<{type}>>}
 */


function* list(action) {
  yield SagasHelper.action(action, CustomersApi.list);
}
/**
 * Update customer
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{customers, type}>|CallEffect|PutEffect<{type}>>}
 */


function* update(action) {
  yield SagasHelper.action(action, CustomersApi.update);
}
/**
 * Delete customer
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{customers, type}>|CallEffect|PutEffect<{type}>>}
 */


function* deleteModel(action) {
  yield SagasHelper.action(action, CustomersApi.delete);
}
/**
 * Send push notification
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{customers, type}>|CallEffect|PutEffect<{type}>>}
 */


function* sendPush(action) {
  yield SagasHelper.action(action, CustomersApi.sendPush);
}
/**
 * Upload user avatar to settings model.
 *
 * @param {Object} action Action
 * @param {string} action.type Action name
 * @param {Object} action.payload Action payload
 *
 * @return {Generator<*, void, ?>}
 */


function* uploadAvatar(action) {
  yield SagasHelper.action(action, CustomersApi.uploadAvatar, null, null);
}
/**
 * Delete user avatar from settings model.
 *
 * @param {Object} action Action
 * @param {string} action.type Action name
 * @param {Object} action.payload Action payload
 *
 * @return {Generator<*, void, ?>}
 */


function* deleteAvatar(action) {
  yield SagasHelper.action(action, CustomersApi.deleteAvatar);
}

export default [takeLatest(CUSTOMER_ACTIONS.CREATE, create), takeLatest(CUSTOMER_ACTIONS.VIEW, view), takeLatest(CUSTOMER_ACTIONS.LIST, list), takeLatest(CUSTOMER_ACTIONS.UPDATE, update), takeLatest(CUSTOMER_ACTIONS.DELETE, deleteModel), takeLatest(CUSTOMER_ACTIONS.SEND_PUSH, sendPush), takeLatest(CUSTOMER_ACTIONS.UPLOAD_AVATAR, uploadAvatar), takeLatest(CUSTOMER_ACTIONS.DELETE_AVATAR, deleteAvatar)];